import React from 'react'
import styled from 'styled-components'

const SVG = styled.svg`
  .st0 {
    fill: #ffffff;
    stroke: #dfdfdf;
    stroke-linecap: round;
    stroke-linejoin: round;
    stroke-miterlimit: 10;
  }
`

const MenuPointer = props => (
  <SVG
    id='Layer_1'
    xmlns='http://www.w3.org/2000/svg'
    viewBox='0 0 92 48'
    {...props}>
    <path className='st0' d='M.7 46.6L46 1.4l45.3 45.2' />
  </SVG>
)

export default MenuPointer



// WEBPACK FOOTER //
// ./src/svg-icons/MenuPointer.js